<template>
    <section class="activity-card-detail">
        <div class="hd">
            <img :src="imgBaseUrl+detail.coverFile.key" alt="" v-if="detail.coverFile">
        </div>
        <div class="bd">
            <div class="hotel-title">{{detail.hotelName}}</div>
            <div class="hotel-name">{{detail.hotelDescribe}}</div>
            <div class="hotel-content" v-html="detail.hotelContent"></div>
        </div>
    </section>
</template>
<style rel="stylesheet/scss" lang="scss">
    .activity-card-detail {
        padding-bottom:50px;
        .hd {
            img {
                width: 100%;
            }
        }
        .bd {
            padding: 20px;
            .hotel {
                &-title {
                    font-size: 18px;
                    color: #555;
                    text-align: left;
                    margin-top: 50px;
                }
                &-name {
                    font-size: 16px;
                    color: #999;
                    text-align: left;
                }
                &-content {
                    text-align: left;
                    margin-top: 30px;
                }
            }
        }
    }
</style>
<script>
    import api from '../../../../api';

    export default {
        data() {
            return {
                imgBaseUrl: api.common.imgBaseUrl,
                detail: {}
            }
        },
        methods: {
            getCardDetails() {
                let id = this.$route.params.id;
                api.personal.getCardDetails(id).then(res => {
                    this.detail = res;
                });
            }
        },
        created() {
            this.getCardDetails();
        }
    }
</script>